import script from "./LogisticsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./LogisticsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./LogisticsDashboard.vue?vue&type=style&index=0&id=a8566b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8566b3e"]])

export default __exports__